import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import media from '../../utils/mediaQueries'
import { offWhite, white } from '../../utils/colors'

const { se, desktop } = media

const Section = ({ children, className, tint }) => (
  <StyledSection className={className} tint={tint}>
    <SectionContainer>{children}</SectionContainer>
  </StyledSection>
)

Section.propTypes = {
  children: PropTypes.array.isRequired,
  className: PropTypes.string,
  tint: PropTypes.bool,
}

Section.defaultProps = {
  className: '',
  tint: false,
}

export default Section

const StyledSection = styled.section`
  background-color:${props => (props.theme.bg)};
  color: ${props => (props.theme.text)};
  ${se &&
    se`
    padding: 30px 0 0 0;
  `}

  ${desktop &&
    desktop`
    padding: 30px 0;
    max-width: 750px;
  `}
`

const SectionContainer = styled.div`
  ${se &&
    se`
    padding: 0 20px;
  `}

  ${desktop &&
    desktop`
    max-width: 1200px;
    padding: 0;
    margin: auto;
  `}
`
